import React from "react";
import PropTypes from "prop-types";
import { Grid, GridColumn } from "semantic-ui-react";
import HomepageWidgetLayout from "./homepage-widget-layout";
import HomepageRecords from "./homepage-records";
import HomepageStats from "./homepage-stats";

const HomePageView = ({ config }) => {
  return (
    <Grid stackable columns={2}>
      <GridColumn>
        <HomepageWidgetLayout title="Check assets">
          <HomepageRecords />
        </HomepageWidgetLayout>
      </GridColumn>
      <GridColumn>
        <HomepageWidgetLayout title="Statistics">
          <HomepageStats />
        </HomepageWidgetLayout>
      </GridColumn>
    </Grid>
  );
};

HomePageView.propTypes = {
  config: PropTypes.object,
};

export default HomePageView;
